export default __webpack_public_path__ + "static/media/html-semantic.421c4e88.jpg";